/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupshide1Inputs */

const en_signupshide1 = /** @type {(inputs: Signupshide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hide`)
};

const de_signupshide1 = /** @type {(inputs: Signupshide1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbergen`)
};

/**
* | output |
* | --- |
* | "Hide" |
*
* @param {Signupshide1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupshide1 = /** @type {((inputs?: Signupshide1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupshide1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupshide1(inputs)
	return de_signupshide1(inputs)
});
export { signupshide1 as "signupsHide" }